import { send } from '../../../../../../../src/network';

type DeleteFavoritePairingResponse = unknown;

export type DeleteFavoritePairingParams = {
  pairingId: number;
};

export function deleteFavoritePairingPath({
  pairingId,
}: DeleteFavoritePairingParams) {
  return `/api/v2/customers/self/favorite_pairings/${pairingId}/`;
}

export async function deleteFavoritePairing({
  pairingId,
}: DeleteFavoritePairingParams) {
  return await send<DeleteFavoritePairingResponse>({
    path: deleteFavoritePairingPath({ pairingId }),
    method: 'DELETE',
  });
}
